module.exports = __webpack_public_path__ + "static/img/pic2.9a074f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/pic2.jpg
// module id = YB3e
// module chunks = 0